import React, { useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

/* Icons */
import CrossIcon from '~/../symbols/cross.svg';

/* Common */
import { Button } from '~/components/common';

/* Config */
import { reactToastifyConfig } from '~/config';

export default function FavoritesRemoveButton({
  vehicleId,
  onFavoriteRemoved,
  removeFavoriteUrl
}) {
    useEffect(() => {
        toast.configure(reactToastifyConfig);
    }, []);

    const removeFavorite = async (event) => {
        event.preventDefault();

        try {
            const response = await axios.post(removeFavoriteUrl, { vehicleUuid: vehicleId });
            if (response.data.success) {
                toast.info('Voertuig verwijderd uit favorieten.');
                if (onFavoriteRemoved) {
                    onFavoriteRemoved(vehicleId);
                }
            } else {
                toast.error('Er is iets verkeerd gegaan, probeer het nogmaals.');
            }
        } catch (error) {
            toast.error('Er is iets verkeerd gegaan, probeer het nogmaals.');
        }
    };

    return (
        <div className="remove-favorite">
            <Button
                className="stretched-link btn--circle btn--remove-favorite"
                theme="light"
                showIcon={true}
                icon={CrossIcon}
                iconSize={8}
                iconClassName={'text-muted--40'}
                onClick={removeFavorite}
            />
        </div>
    );
}
